import PasswordStrength from './PasswordStrength';

export default PasswordStrength;